module.exports = __webpack_public_path__ + "img/验证码图片.24bccc1c.png";